import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import accountService from "../service-api/accountService";

// Initial state
const initialState = {
  data: [],
  error: null,
  isLoading: true,
  requisitionByAccounts: [],
  assignToAccounts: [],
};

export const fetchAllAccounts = createAsyncThunk(
  "data/fetchAllAccounts",
  async () => {
    const response = await accountService.fetchAllAccounts();
    return response.data;
  }
);

export const fetchAssignToAccounts = createAsyncThunk(
  "data/fetchAssignToAccounts",
  async () => {
    const response = await accountService.fetchAssignToAccounts();
    return response.data;
  }
);

export const fetchRequisitionByAccounts = createAsyncThunk(
  "data/fetchRequisitionByAccounts",
  async () => {
    const response = await accountService.fetchRequisitionByAccounts();
    return response.data;
  }
);

export const addAccount = createAsyncThunk(
  "data/addAccount",
  async ({ obj }, { dispatch }) => {
    const response = await accountService.addAccount(obj);
    dispatch(fetchRequisitionByAccounts());
    dispatch(fetchAssignToAccounts());
    return response.data;
  }
);

export const updateAccount = createAsyncThunk(
  "data/updateAccount",
  async ({ id, obj }, { dispatch }) => {
    const response = await accountService.updateAccount(id, obj);
    dispatch(fetchRequisitionByAccounts());
    dispatch(fetchAssignToAccounts());
    return response.data;
  }
);

// Create slice
const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAccounts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllAccounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(fetchAllAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchAssignToAccounts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAssignToAccounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.assignToAccounts = action.payload.value;
      })
      .addCase(fetchAssignToAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchRequisitionByAccounts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchRequisitionByAccounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.requisitionByAccounts = action.payload.value;
      })
      .addCase(fetchRequisitionByAccounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateAccount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAccount.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateAccount.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(addAccount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addAccount.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addAccount.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default accountSlice.reducer;
